import React, { useState, useEffect } from 'react';
import { Box, Typography, FormControl, Select, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, Button } from '@mui/material';
import axios from 'axios';
import { saveAs } from 'file-saver';
import moment from 'moment';

const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local


// Função para obter o token CSRF do cookie
function getCsrfToken() {
    const csrfToken = document.cookie.split(';').find(cookie => cookie.trim().startsWith('csrftoken='));
    return csrfToken ? csrfToken.split('=')[1] : null;
}

// Adiciona o CSRF token ao cabeçalho das requisições
const csrfToken = getCsrfToken();
axios.defaults.headers.common['X-CSRFToken'] = csrfToken;

console.log('CSRF Token:', csrfToken); // Log para verificar se o token CSRF foi obtido corretamente

const PresencaSheets = () => {
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth()); // O mês atual ainda não está completo, então inicializa com o mês anterior
    const [employees, setEmployees] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);

    useEffect(() => {
        // Fetch employees from API
        const fetchEmployees = async () => {
            const token = localStorage.getItem('access');
            try {
                const response = await axios.get(`${apiBaseURL}/api/empregados/`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setEmployees(response.data);
            } catch (error) {
                console.error('Erro ao buscar empregados:', error);
            }
        };

        fetchEmployees();
    }, []);

    const handleYearChange = (event) => {
        const selectedYear = event.target.value;
        setYear(selectedYear);
        // Se o ano selecionado é o atual, limitar a seleção do mês ao último mês completo
        if (selectedYear === new Date().getFullYear()) {
            setMonth(new Date().getMonth());
        } else {
            setMonth(11); // Para anos anteriores, permitir até dezembro
        }
    };

    const handleMonthChange = (event) => {
        setMonth(event.target.value);
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            const allEmployeeIds = employees.map(emp => emp.id);
            setSelectedEmployees(allEmployeeIds);
        } else {
            setSelectedEmployees([]);
        }
    };

    const handleSelectEmployee = (employeeId) => {
        if (selectedEmployees.includes(employeeId)) {
            setSelectedEmployees(selectedEmployees.filter(id => id !== employeeId));
        } else {
            setSelectedEmployees([...selectedEmployees, employeeId]);
        }
    };

    // Função para baixar as folhas de presença
    const handleDownload = async () => {
        console.log('Enviando requisição de download com CSRF Token:', csrfToken);
        try {
            const token = localStorage.getItem('access');
            const response = await axios.post(`${apiBaseURL}/api/presenca/download/`, {
                year,
                month: month + 1, // Corrige para que o mês vá de 1 a 12
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'X-CSRFToken': csrfToken,
                },
                responseType: 'blob',
            });
    
            const blob = new Blob([response.data], { type: 'application/zip' });
            saveAs(blob, `folhas_de_presenca_${year}_${month + 1}.zip`);
        } catch (error) {
            console.error('Erro ao baixar as folhas de presença:', error);
            alert('Erro ao baixar as folhas de presença.');
        }
    };
    


    const currentMonth = new Date().getMonth(); // 0 (Janeiro) até 11 (Dezembro)
    const monthsToShow = Array.from({ length: year === new Date().getFullYear() ? currentMonth : 12 }, (_, i) => i);

    return (
        <Box sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>Folhas de Presença</Typography>

            <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
                <FormControl>
                    <Select value={year} onChange={handleYearChange}>
                        {[...Array(new Date().getFullYear() - 2019).keys()].map(i => {
                            const y = new Date().getFullYear() - i;
                            return <MenuItem key={y} value={y}>{y}</MenuItem>;
                        })}
                    </Select>
                </FormControl>
                <FormControl>
                    <Select value={month} onChange={handleMonthChange}>
                        {monthsToShow.map(m => (
                            <MenuItem key={m} value={m}>
                                {moment().month(m).format('MMMM')}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox">
                            <Checkbox
                                indeterminate={selectedEmployees.length > 0 && selectedEmployees.length < employees.length}
                                checked={employees.length > 0 && selectedEmployees.length === employees.length}
                                onChange={handleSelectAll}
                            />
                        </TableCell>
                        <TableCell>Nome do Empregado</TableCell>
                        <TableCell>Turno</TableCell>
                        <TableCell>Seção</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {employees.map(employee => (
                        <TableRow key={employee.id}>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={selectedEmployees.includes(employee.id)}
                                    onChange={() => handleSelectEmployee(employee.id)}
                                />
                            </TableCell>
                            <TableCell>{employee.nome_completo}</TableCell>
                            <TableCell>{employee.turno}</TableCell>
                            <TableCell>{employee.seccao}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {selectedEmployees.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                    <Button variant="contained" color="primary" onClick={handleDownload}>
                        Download Folhas de Presença
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default PresencaSheets;
